import React from 'react';
import classnames from 'classnames';
import ListContext from './ListContext';
import styles from './ListStyles.module.css';
import './SerializedStyles.css';
import type { ComponentProps, ListElement } from '../../../types/aha-editor';
import type { ListType } from '../constants';

interface ListProps extends ComponentProps<ListElement> {
  type: ListType;
}

const List: React.FC<ListProps> = ({ type, children, attributes, element }) => {
  let Tag: 'ol' | 'ul' | 'dl';

  switch (type) {
    case 'ol':
      Tag = 'ol';
      break;

    case 'dl':
      Tag = 'dl';
      break;

    default:
      Tag = 'ul';
      break;
  }

  const className = classnames({
    [styles.ulChecklist]: type === 'checklist',
  });

  // Add start attribute for ordered lists if specified
  const additionalProps: JSX.IntrinsicElements['ol'] = {};
  const { list_start } = element;
  if (type === 'ol' && list_start !== undefined) {
    additionalProps.start = list_start;

    // Override margin-left for >2 digits
    const lastNumber = list_start + element.children.length - 1;
    const numDigits = String(lastNumber).length;
    if (numDigits > 2) {
      additionalProps.style = { marginLeft: `${numDigits + 1}ch` };
    }
  }

  return (
    <Tag className={className} {...attributes} {...additionalProps}>
      <ListContext.Provider value={type}>{children}</ListContext.Provider>
    </Tag>
  );
};

export default List;
